import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Clock, RefreshCw, Info, Lock, CreditCard } from 'lucide-react';
// --- Custom Bespoke SVG Illustrations for Extras ---
const DishwasherIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1008">
    <rect x="12" y="12" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-1009" />
    <rect x="16" y="16" width="32" height="8" rx="2" fill="#2BBCB3" data-id="element-1010" />
    <rect x="16" y="28" width="32" height="20" rx="2" fill="#E8F6F5" data-id="element-1011" />
    <circle cx="24" cy="38" r="6" fill="#F5C842" data-id="element-1012" />
    <circle cx="40" cy="38" r="6" fill="#F5C842" data-id="element-1013" />
    <path d="M16 28 L48 28" stroke="#1B1B2F" strokeWidth="2" data-id="element-1014" />
  </svg>;
const LaundryIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1015">
    <rect x="14" y="10" width="36" height="44" rx="4" fill="#1B1B2F" data-id="element-1016" />
    <rect x="18" y="14" width="28" height="8" rx="2" fill="#2BBCB3" data-id="element-1017" />
    <circle cx="32" cy="36" r="12" fill="#E8F6F5" data-id="element-1018" />
    <circle cx="32" cy="36" r="8" fill="#2BBCB3" fillOpacity="0.3" data-id="element-1019" />
    <circle cx="22" cy="18" r="2" fill="#1B1B2F" data-id="element-1020" />
    <circle cx="28" cy="18" r="2" fill="#1B1B2F" data-id="element-1021" />
  </svg>;
const OvenIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1022">
    <rect x="12" y="14" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-1023" />
    <rect x="16" y="18" width="32" height="10" rx="2" fill="#2BBCB3" data-id="element-1024" />
    <rect x="16" y="32" width="32" height="18" rx="2" fill="#E8F6F5" data-id="element-1025" />
    <rect x="22" y="36" width="20" height="10" rx="1" fill="#1B1B2F" data-id="element-1026" />
    <circle cx="20" cy="23" r="2" fill="#1B1B2F" data-id="element-1027" />
    <circle cx="28" cy="23" r="2" fill="#1B1B2F" data-id="element-1028" />
    <circle cx="36" cy="23" r="2" fill="#1B1B2F" data-id="element-1029" />
    <circle cx="44" cy="23" r="2" fill="#1B1B2F" data-id="element-1030" />
  </svg>;
const FridgeIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1031">
    <rect x="16" y="8" width="32" height="48" rx="4" fill="#1B1B2F" data-id="element-1032" />
    <rect x="20" y="12" width="24" height="16" rx="2" fill="#2BBCB3" data-id="element-1033" />
    <rect x="20" y="30" width="24" height="22" rx="2" fill="#E8F6F5" data-id="element-1034" />
    <rect x="24" y="16" width="2" height="8" fill="#1B1B2F" data-id="element-1035" />
    <rect x="24" y="34" width="2" height="12" fill="#1B1B2F" data-id="element-1036" />
  </svg>;
const GarageIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1037">
    <path d="M8 28 L32 12 L56 28 L56 52 L8 52 Z" fill="#1B1B2F" data-id="element-1038" />
    <rect x="16" y="32" width="32" height="20" fill="#E8F6F5" data-id="element-1039" />
    <rect x="16" y="36" width="32" height="2" fill="#2BBCB3" data-id="element-1040" />
    <rect x="16" y="42" width="32" height="2" fill="#2BBCB3" data-id="element-1041" />
    <rect x="16" y="48" width="32" height="2" fill="#2BBCB3" data-id="element-1042" />
    <path d="M44 24 L52 16 L54 18 L46 26 Z" fill="#F5C842" data-id="element-1043" />
    <circle cx="52" cy="16" r="3" fill="#2BBCB3" data-id="element-1044" />
  </svg>;
const BlindsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1045">
    <rect x="16" y="12" width="32" height="6" rx="1" fill="#1B1B2F" data-id="element-1046" />
    <rect x="18" y="22" width="28" height="4" fill="#2BBCB3" data-id="element-1047" />
    <rect x="18" y="30" width="28" height="4" fill="#2BBCB3" data-id="element-1048" />
    <rect x="18" y="38" width="28" height="4" fill="#2BBCB3" data-id="element-1049" />
    <rect x="18" y="46" width="28" height="4" fill="#2BBCB3" data-id="element-1050" />
    <rect x="42" y="18" width="2" height="36" fill="#1B1B2F" data-id="element-1051" />
    <circle cx="43" cy="54" r="3" fill="#F5C842" data-id="element-1052" />
  </svg>;
const CabinetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1053">
    <rect x="12" y="12" width="40" height="40" rx="2" fill="#1B1B2F" data-id="element-1054" />
    <rect x="14" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-1055" />
    <rect x="33" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-1056" />
    <rect x="27" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-1057" />
    <rect x="35" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-1058" />
  </svg>;
const WindowsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1059">
    <rect x="16" y="12" width="32" height="40" rx="2" fill="#1B1B2F" data-id="element-1060" />
    <rect x="20" y="16" width="10" height="16" fill="#E8F6F5" data-id="element-1061" />
    <rect x="34" y="16" width="10" height="16" fill="#E8F6F5" data-id="element-1062" />
    <rect x="20" y="34" width="10" height="14" fill="#E8F6F5" data-id="element-1063" />
    <rect x="34" y="34" width="10" height="14" fill="#E8F6F5" data-id="element-1064" />
    <path d="M20 16 L30 32 M34 16 L44 32" stroke="#2BBCB3" strokeWidth="2" strokeOpacity="0.5" data-id="element-1065" />
  </svg>;
// --- Main Component ---
export function MoveInOutForm() {
  // Step 3 State
  const [moveType, setMoveType] = useState('Move-In');
  const [parking, setParking] = useState('Free on street');
  const [pets, setPets] = useState('None');
  // Step 4 State (Extras)
  const [selectedExtras, setSelectedExtras] = useState<string[]>([]);
  const toggleExtra = (id: string) => {
    setSelectedExtras(prev => prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]);
  };
  const extrasList = [{
    id: 'dishwasher',
    label: 'Washing dishes',
    icon: DishwasherIcon
  }, {
    id: 'laundry',
    label: 'Laundry (wash & fold)',
    icon: LaundryIcon
  }, {
    id: 'oven',
    label: 'Inside of oven',
    icon: OvenIcon
  }, {
    id: 'fridge',
    label: 'Inside of fridge',
    icon: FridgeIcon
  }, {
    id: 'garage',
    label: 'Garage Sweep',
    icon: GarageIcon
  }, {
    id: 'blinds',
    label: 'Wet Wipe Blinds',
    icon: BlindsIcon
  }, {
    id: 'cabinets',
    label: 'Inside Cabinets',
    icon: CabinetsIcon
  }, {
    id: 'windows',
    label: 'Windows',
    icon: WindowsIcon
  }];
  // Step 5 State
  const [frequency, setFrequency] = useState('One time');
  // Step 6 State
  const [selectedDate, setSelectedDate] = useState('04/04');
  const [selectedTime, setSelectedTime] = useState('14:00');
  const dates = [{
    day: 'M',
    date: '30/03'
  }, {
    day: 'Tu',
    date: '31/03'
  }, {
    day: 'W',
    date: '01/04'
  }, {
    day: 'Th',
    date: '02/04'
  }, {
    day: 'F',
    date: '03/04'
  }, {
    day: 'Sa',
    date: '04/04'
  }, {
    day: 'Su',
    date: '05/04'
  }];
  // Step 7 State
  const [paymentMethod, setPaymentMethod] = useState('By Credit/Debit Card');
  // Helper for Step Headings
  const StepHeading = ({
    number,
    title,
    subtitle
  }: {
    number: string;
    title: string;
    subtitle?: string;
  }) => <div className="mb-8" data-id="element-1066">
      <div className="flex items-center gap-4 mb-2" data-id="element-1067">
        <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center text-white font-heading font-bold text-xl shadow-md shrink-0" data-id="element-1068">
          {number}
        </div>
        <h3 className="text-2xl md:text-3xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-1069">
          {title}
        </h3>
      </div>
      {subtitle && <p className="text-gray-500 text-base ml-14 pb-4 border-b border-gray-100" data-id="element-1070">
          {subtitle}
        </p>}
      {!subtitle && <div className="ml-14 pb-4 border-b border-gray-100" data-id="element-1071"></div>}
    </div>;
  return <main className="min-h-screen bg-light pb-24" data-id="element-1072">
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-1073">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-1074"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-1075">
          {/* Breadcrumb */}
          <div className="text-sm font-medium text-white/50 mb-6 uppercase tracking-wider" data-id="element-1076">
            <Link to="/" className="hover:text-accent transition-colors" data-id="element-1077">
              Home
            </Link>
            <span className="mx-2" data-id="element-1078">/</span>
            <Link to="/services" className="hover:text-accent transition-colors" data-id="element-1079">
              Our Services
            </Link>
            <span className="mx-2" data-id="element-1080">/</span>
            <span className="text-accent" data-id="element-1081">Book Online</span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1082">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight mb-4" data-id="element-1083">
              Move-In / Move-Out
            </h1>
            <p className="text-xl md:text-2xl font-serif italic text-white/60" data-id="element-1084">
              Book Online in 60 Seconds
            </p>
          </motion.div>
        </div>
      </section>

      {/* Form & Sidebar Container */}
      <div className="container mx-auto px-6 md:px-12 -mt-8 relative z-20" data-id="element-1085">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-1086">
          {/* Main Form Area */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8 xl:col-span-9 bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-1087">
            <div className="text-center mb-16 flex flex-col items-center" data-id="element-1088">
              <div className="w-24 h-24 rounded-full border-2 border-accent/20 flex items-center justify-center mb-6 bg-accent/5" data-id="element-1089">
                <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1090">
                  <rect x="16" y="24" width="32" height="28" rx="2" fill="#1B1B2F" data-id="element-1091" />
                  <path d="M16 24 L32 12 L48 24 Z" fill="#2BBCB3" data-id="element-1092" />
                  <rect x="24" y="32" width="16" height="4" fill="#E8F6F5" data-id="element-1093" />
                  <path d="M32 32 L32 44 M26 38 L38 38" stroke="#F5C842" strokeWidth="3" strokeLinecap="round" data-id="element-1094" />
                </svg>
              </div>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary uppercase tracking-wide mb-3" data-id="element-1095">
                Move-In / Move-Out Cleaning
              </h2>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto" data-id="element-1096">
                It only takes 60 seconds to Book your Home Cleaning!
              </p>
              <span className="text-accent text-sm font-bold uppercase tracking-widest mt-4" data-id="element-1097">
                Move-In / Move-Out Cleaning
              </span>
            </div>

            <form className="space-y-20" onSubmit={e => e.preventDefault()} data-id="element-1098">
              {/* STEP 1 */}
              <section data-id="element-1099">
                <StepHeading number="1" title="Contact Information" data-id="element-1100" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-1101">
                  <input type="text" placeholder="First Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1102" />
                  <input type="text" placeholder="Last Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1103" />
                  <input type="email" placeholder="Email" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1104" />
                  <div className="flex rounded-xl border border-gray-200 bg-gray-50 focus-within:bg-white focus-within:ring-2 focus-within:ring-accent focus-within:border-accent transition-all overflow-hidden" data-id="element-1105">
                    <div className="px-4 py-4 border-r border-gray-200 bg-gray-100 flex items-center justify-center text-gray-600 font-medium" data-id="element-1106">
                      🇬🇧 ▾
                    </div>
                    <input type="tel" placeholder="Phone Number" className="w-full px-5 py-4 outline-none bg-transparent text-primary" data-id="element-1107" />
                  </div>
                </div>
              </section>

              {/* STEP 2 */}
              <section data-id="element-1108">
                <StepHeading number="2" title="Cleaning Location" data-id="element-1109" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-1110">
                  <input type="text" placeholder="Enter a location" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1111" />
                  <input type="text" placeholder="Unit/Apt/Suite #" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1112" />
                  <input type="text" placeholder="City" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1113" />
                  <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1114" />
                </div>
                <div className="ml-0 md:ml-14 mt-4" data-id="element-1115">
                  <a href="#" className="text-accent hover:text-primary transition-colors flex items-center gap-2 font-medium" data-id="element-1116">
                    See what's included in our Move-In / Move-Out Cleaning
                    service <Info size={16} data-id="element-1117" />
                  </a>
                </div>
              </section>

              {/* STEP 3 */}
              <section data-id="element-1118">
                <StepHeading number="3" title="Tell us about the cleaning" data-id="element-1119" />
                <div className="space-y-8 ml-0 md:ml-14" data-id="element-1120">
                  <div data-id="element-1121">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1122">
                      How many hours and cleaners would you like to book?
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1123">
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1124">
                        <option data-id="element-1125">2 Hours</option>
                        <option data-id="element-1126">3 Hours</option>
                        <option data-id="element-1127">4 Hours</option>
                        <option data-id="element-1128">5 Hours</option>
                        <option data-id="element-1129">6 Hours</option>
                        <option data-id="element-1130">7 Hours</option>
                        <option data-id="element-1131">8 Hours</option>
                      </select>
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1132">
                        <option data-id="element-1133">1 Cleaner</option>
                        <option data-id="element-1134">2 Cleaners</option>
                        <option data-id="element-1135">3 Cleaners</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-1136">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1137">
                      Move Type
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-1138">
                      {['Move-In', 'Move-Out'].map(opt => <button key={opt} type="button" onClick={() => setMoveType(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${moveType === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1139">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1140">
                    <label className="text-primary font-medium text-lg" data-id="element-1141">
                      Bedrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1142">
                      <option data-id="element-1143">Studio / 1 Bedroom</option>
                      <option data-id="element-1144">2 Bedrooms</option>
                      <option data-id="element-1145">3 Bedrooms</option>
                      <option data-id="element-1146">4 Bedrooms</option>
                      <option data-id="element-1147">5+ Bedrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1148">
                    <label className="text-primary font-medium text-lg" data-id="element-1149">
                      Bathrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1150">
                      <option data-id="element-1151">1 Bathroom</option>
                      <option data-id="element-1152">2 Bathrooms</option>
                      <option data-id="element-1153">3 Bathrooms</option>
                      <option data-id="element-1154">4+ Bathrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1155">
                    <label className="text-primary font-medium text-lg" data-id="element-1156">
                      Additional Rooms (dining rooms, living room, office, etc)
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1157">
                      <option data-id="element-1158">No additional rooms</option>
                      <option data-id="element-1159">1 Room</option>
                      <option data-id="element-1160">2 Rooms</option>
                      <option data-id="element-1161">3 Rooms</option>
                      <option data-id="element-1162">4+ Rooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-1163">
                    <label className="text-primary font-medium text-lg" data-id="element-1164">
                      Number of Floors (incl basement)
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-1165">
                      <option data-id="element-1166">1 Floor</option>
                      <option data-id="element-1167">2 Floors</option>
                      <option data-id="element-1168">3 Floors</option>
                      <option data-id="element-1169">4+ Floors</option>
                    </select>
                  </div>

                  <div data-id="element-1170">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1171">
                      Parking
                    </label>
                    <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-1172">
                      {['Free on street', 'Free home parking', 'Parking meters', 'Paid parking lot'].map(opt => <button key={opt} type="button" onClick={() => setParking(opt)} className={`flex-1 min-w-[140px] py-3.5 px-4 text-sm font-medium transition-all duration-300 ${parking === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-1173">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-1174">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1175">
                      Do you have any pets? (Required for safety & allergy
                      reasons)
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-1176">
                      {['None', 'Dog', 'Cat'].map(opt => <button key={opt} type="button" onClick={() => setPets(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${pets === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1177">
                          {opt}
                        </button>)}
                    </div>
                  </div>
                </div>
              </section>

              {/* STEP 4 */}
              <section data-id="element-1178">
                <StepHeading number="4" title="Move-In / Move-Out Extras" subtitle="Free up more of your precious time for what matters most!" data-id="element-1179" />
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ml-0 md:ml-14" data-id="element-1180">
                  {extrasList.map(({
                  id,
                  label,
                  icon: Icon
                }) => {
                  const isSelected = selectedExtras.includes(id);
                  return <button key={id} type="button" onClick={() => toggleExtra(id)} className={`flex flex-col items-center justify-center p-6 rounded-2xl border-2 transition-all duration-300 group ${isSelected ? 'border-accent bg-accent/5 shadow-md' : 'border-gray-100 bg-gray-50 hover:border-accent/30 hover:bg-gray-100'}`} data-id="element-1181">
                        <div className={`mb-4 transform transition-transform duration-300 ${isSelected ? 'scale-110' : 'group-hover:scale-105'}`} data-id="element-1182">
                          <Icon data-id="element-1183" />
                        </div>
                        <span className={`text-sm text-center font-medium ${isSelected ? 'text-primary font-bold' : 'text-gray-600'}`} data-id="element-1184">
                          {label}
                        </span>
                      </button>;
                })}
                </div>
              </section>

              {/* STEP 5 */}
              <section data-id="element-1185">
                <StepHeading number="5" title="Select Frequency" data-id="element-1186" />
                <div className="ml-0 md:ml-14" data-id="element-1187">
                  <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-1188">
                    {['One time'].map(opt => <button key={opt} type="button" onClick={() => setFrequency(opt)} className={`flex-1 py-4 px-4 text-sm font-medium transition-all duration-300 ${frequency === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-1189">
                        {opt}
                      </button>)}
                  </div>
                </div>
              </section>

              {/* STEP 6 */}
              <section data-id="element-1190">
                <StepHeading number="6" title="Date of service" subtitle="For recurring services, each one will commence on the same day and time as selected for the first service." data-id="element-1191" />
                <div className="ml-0 md:ml-14 space-y-8" data-id="element-1192">
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1193">
                    <span className="font-bold text-primary mb-3" data-id="element-1194">
                      Choose a timezone
                    </span>
                    <div className="flex items-center gap-3" data-id="element-1195">
                      <span className="text-gray-500 text-sm" data-id="element-1196">
                        Our Company's
                      </span>
                      <div className="w-12 h-6 bg-accent rounded-full relative cursor-pointer" data-id="element-1197">
                        <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" data-id="element-1198"></div>
                      </div>
                      <span className="text-primary font-medium text-sm" data-id="element-1199">
                        Yours
                      </span>
                    </div>
                  </div>

                  <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-1200">
                    <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50" data-id="element-1201">
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-1202">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1203">
                          <circle cx="12" cy="12" r="10" data-id="element-1204"></circle>
                          <polyline points="12 8 8 12 12 16" data-id="element-1205"></polyline>
                          <line x1="16" y1="12" x2="8" y2="12" data-id="element-1206"></line>
                        </svg>
                      </button>
                      <div className="flex gap-2 sm:gap-6 overflow-x-auto px-2 hide-scrollbar" data-id="element-1207">
                        {dates.map(d => <button key={d.date} type="button" onClick={() => setSelectedDate(d.date)} className={`flex flex-col items-center p-2 rounded-lg min-w-[60px] transition-colors ${selectedDate === d.date ? 'bg-accent/10 text-accent' : 'hover:bg-gray-100 text-gray-600'}`} data-id="element-1208">
                            <span className="text-sm font-medium mb-1" data-id="element-1209">
                              {d.day}
                            </span>
                            <span className="text-xs flex items-center gap-1" data-id="element-1210">
                              <Calendar size={12} data-id="element-1211" />
                              {d.date}
                            </span>
                          </button>)}
                      </div>
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-1212">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1213">
                          <circle cx="12" cy="12" r="10" data-id="element-1214"></circle>
                          <polyline points="12 16 16 12 12 8" data-id="element-1215"></polyline>
                          <line x1="8" y1="12" x2="16" y2="12" data-id="element-1216"></line>
                        </svg>
                      </button>
                    </div>

                    <div className="p-6 bg-white flex flex-col items-end gap-3" data-id="element-1217">
                      {['14:00', '15:00'].map(time => <button key={time} type="button" onClick={() => setSelectedTime(time)} className={`flex items-center gap-2 px-6 py-2 rounded-full border transition-all ${selectedTime === time ? 'border-accent bg-accent text-white shadow-md' : 'border-gray-200 text-accent hover:border-accent hover:bg-accent/5'}`} data-id="element-1218">
                          <Clock size={16} data-id="element-1219" />
                          {time}
                        </button>)}
                    </div>
                  </div>

                  <p className="text-gray-500 text-sm italic" data-id="element-1220">
                    For same day bookings, a Customer service agent will call
                    you.
                  </p>

                  <div data-id="element-1221">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-1222">
                      Are there any additional details we need to know?
                    </label>
                    <textarea className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all min-h-[120px] text-primary resize-y" data-id="element-1223"></textarea>
                  </div>
                </div>
              </section>

              {/* STEP 7 */}
              <section data-id="element-1224">
                <StepHeading number="7" title="Payment details" subtitle="Select your method of payment. Credit Card charges may be pre-authorized, but applied only after the service event is complete." data-id="element-1225" />
                <div className="ml-0 md:ml-14 space-y-6" data-id="element-1226">
                  <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-1227">
                    {['By Cash', 'By Check', 'By Credit/Debit Card', 'By Interac e-Transfer'].map(opt => <button key={opt} type="button" onClick={() => setPaymentMethod(opt)} className={`flex-1 min-w-[150px] py-4 px-4 text-sm font-medium transition-all duration-300 ${paymentMethod === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-1228">
                        {opt}
                      </button>)}
                  </div>

                  {paymentMethod === 'By Credit/Debit Card' && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} className="space-y-4" data-id="element-1229">
                      <input type="text" placeholder="name on credit card" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1230" />

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1231">
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border-2 border-accent bg-accent/5 text-primary font-medium" data-id="element-1232">
                          <CreditCard className="text-accent" data-id="element-1233" />
                          Card
                        </button>
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-primary font-medium transition-colors" data-id="element-1234">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1235">
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#F5C842" data-id="element-1236" />
                            <path d="M15 10.5H9V13.5H15V10.5Z" fill="#1B1B2F" data-id="element-1237" />
                          </svg>
                          Google Pay
                        </button>
                      </div>

                      <div className="flex items-center gap-2 text-accent text-sm font-bold mt-2" data-id="element-1238">
                        <Lock size={14} data-id="element-1239" />
                        Secure, fast checkout with Link
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1240">
                          <polyline points="6 9 12 15 18 9" data-id="element-1241"></polyline>
                        </svg>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-12 gap-4" data-id="element-1242">
                        <div className="sm:col-span-6 relative" data-id="element-1243">
                          <input type="text" placeholder="Card number" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1244" />
                          <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-1" data-id="element-1245">
                            <div className="w-8 h-5 bg-blue-800 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-1246">
                              VISA
                            </div>
                            <div className="w-8 h-5 bg-orange-500 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-1247">
                              MC
                            </div>
                          </div>
                        </div>
                        <input type="text" placeholder="Expiration date" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1248" />
                        <input type="text" placeholder="Security code" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1249" />
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1250">
                        <select className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-1251">
                          <option data-id="element-1252">United Kingdom</option>
                          <option data-id="element-1253">United States</option>
                          <option data-id="element-1254">Canada</option>
                        </select>
                        <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-1255" />
                      </div>

                      <p className="text-xs text-gray-500 mt-4 leading-relaxed" data-id="element-1256">
                        By providing your card information, you allow Smith and
                        Jengs Cleaning Services to charge your card for future
                        payments in accordance with their terms.
                      </p>
                      <p className="text-xs text-gray-400 text-center italic mt-2" data-id="element-1257">
                        I authorize the operator to send instructions to the
                        financial institution that issued my card to take
                        payments from my card account in accordance with the
                        terms of my agreement with you.
                      </p>
                    </motion.div>}

                  <div className="space-y-3 pt-6 flex flex-col items-center" data-id="element-1258">
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-1259">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-accent transition-colors" data-id="element-1260">
                        <div className="w-3 h-3 bg-transparent rounded-sm" data-id="element-1261"></div>
                      </div>
                      <span className="text-primary text-lg" data-id="element-1262">
                        I would like to be notified by email.
                      </span>
                    </label>
                  </div>
                </div>
              </section>

              {/* Submit */}
              <div className="pt-12 pb-4 flex justify-center border-t border-gray-100" data-id="element-1263">
                <button type="submit" className="bg-[#5CB85C] hover:bg-[#4cae4c] text-white px-16 py-4 rounded text-xl font-bold transition-all shadow-md hover:shadow-lg" data-id="element-1264">
                  Book Now
                </button>
              </div>
            </form>
          </motion.div>

          {/* Sidebar - Booking Summary */}
          <div className="lg:col-span-4 xl:col-span-3" data-id="element-1265">
            <div className="sticky top-32 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-1266">
              <div className="bg-gray-50 p-6 border-b border-gray-100" data-id="element-1267">
                <h3 className="text-xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-1268">
                  Booking Summary
                </h3>
              </div>

              <div className="p-6 space-y-4 border-b border-gray-100" data-id="element-1269">
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1270">
                  <Calendar size={16} className="text-accent" data-id="element-1271" />
                  <span data-id="element-1272">4 Apr 2026</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1273">
                  <Clock size={16} className="text-accent" data-id="element-1274" />
                  <span data-id="element-1275">14:00</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-1276">
                  <RefreshCw size={16} className="text-accent" data-id="element-1277" />
                  <span data-id="element-1278">One time</span>
                </div>
              </div>

              <div className="p-6 space-y-3 border-b border-gray-100 text-sm" data-id="element-1279">
                <div className="flex justify-between text-gray-600" data-id="element-1280">
                  <span data-id="element-1281">Move-In/Move-Out Cleaning</span>
                  <span data-id="element-1282">£50.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-1283">
                  <span data-id="element-1284">DISCOUNTS</span>
                  <span data-id="element-1285">£0.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-1286">
                  <span data-id="element-1287">EXTRAS</span>
                  <span data-id="element-1288">£0.00</span>
                </div>
              </div>

              <div className="p-6 bg-gray-50 flex justify-between items-center" data-id="element-1289">
                <span className="font-bold text-primary text-lg" data-id="element-1290">TOTAL</span>
                <span className="font-bold text-primary text-lg" data-id="element-1291">£50.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}